import React from 'react';
import { Alert } from 'antd';
import intl from 'react-intl-universal';

import styles from './index.module.scss';

export const VipAlertText = (props) => {
  const { payAmount, vipInfo } = props;
  // balance大于等于0
  if (vipInfo.balance >= 0 && vipInfo.balance < payAmount) {
    return (
      <Alert
        className={styles.vipAlertText}
        type="warning"
        message={intl.get('bill_msg_vip_payment_prompt')}
        banner
      />
    );
  }

  return null;
};
